import Grid from "@mui/material/Grid2"
import React, { useEffect, useRef, useState } from "react"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { allLabelData, allLabelOption, BREAK, CREATE_APPOINTMENT, EDIT_APPOINTMENT } from "../../utils/constants"
import { getMonthFormattedDate } from "../../utils/Helpers"
import BasicModal from "../GlobalComponents/BasicModal"
import CalendarComponents from "./CalendarComponents"
import { EventCards, getGroupedEvents } from "./Events"
import "./index.css"
import Sidebar from "./Sidebar"

function CalenderSection(props) {
  const [data, setData] = useState([])
  const [currentDate, setCurrentDate] = useState(new Date())
  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedEvents, setSelectedEvents] = useState([])
  const [selectedUsersData, setSelectedUsersData] = useState([])
  const [activeUsers, setActiveUsers] = useState([])
  const [view, setView] = useState("month")
  const [selectedUsers, setSelectedUsers] = useState("")
  const allEvents = props?.allEvents
  const refData = useRef({})
  const { getScheduleData = () => { }, onSelectEventCard } = props

  console.log("allEventsallEvents", {
    allEvents,
    selectedUsersData,
    activeUsers,
    selectedEvents,
  })

  const handleView = (view) => {
    setView(view)
  }

  useEffect(() => {
    handleNavigate("")
    
  }, [view, props?.view])

  useEffect(() => {
    if(props?.reloadData) {
      handleNavigate("")
      props.setReloadData(false)
    }
  }, [props?.reloadData])

  const [filteredEvents, setFilteredEvents] = useState([])

  useEffect(() => {
    let filteredData = selectedEvents

    if (activeUsers?._id !== allLabelData?._id) {
      filteredData = selectedEvents?.filter((event) => {
        return event?.doctorId === activeUsers?.doctorId
      })
    }

    setFilteredEvents(filteredData)
  }, [activeUsers, selectedEvents])

  useEffect(() => {
    handleToday()
  }, [])

  // Navigation handlers
  const handleNavigate = (action, cDate=currentDate) => {
    const newDate = new Date(cDate)
    let endDate = new Date(newDate); 
    let startDate = new Date(newDate); 

    if (view === "week") {
      if (action === "PREV") {
        newDate.setDate(cDate.getDate() - 7)
      } else if (action === "NEXT") {
        newDate.setDate(cDate.getDate() + 7)
      }

      // Set startDate to the beginning of the week (Sunday)
      startDate = new Date(newDate);
      startDate.setDate(newDate.getDate() - newDate.getDay());

      // Set endDate to the end of the week (Saturday)
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 7);

    } else if (view === "month") {
      if (action === "PREV") {
        newDate.setMonth(cDate.getMonth() - 1)
      } else if (action === "NEXT") {
        newDate.setMonth(cDate.getMonth() + 1)
      }

      startDate = new Date(newDate); 
      startDate.setDate(1);

      endDate = new Date(newDate); 
      endDate.setDate(1);
      endDate.setMonth(endDate.getMonth() + 1);
    } else {
      if (action === "PREV") {
        newDate.setDate(cDate.getDate() - 1)
      } else if (action === "NEXT") {
        newDate.setDate(cDate.getDate() + 1)
      }

      startDate = new Date(newDate); 

      endDate = new Date(newDate);
      endDate.setDate(endDate.getDate() + 1);
    }

    // console.log("cDate newDate", newDate)
    // console.log("handleNavigate", {action, isDifferentMonth, cDate, newDate, endDate})

    getScheduleData("", null, startDate, endDate)

    setCurrentDate(newDate)
    setSelectedDate(newDate)
  }

  const handleToday = () => {
    let today = new Date()
    setCurrentDate(today)
    setSelectedDate(today)
    handleNavigate("", today)
  }

  useEffect(() => {
    let filteredUserData = { ...allLabelOption }
    // console.log("filteredUserData123", refData)

    selectedEvents.forEach((event) => {
      filteredUserData[event?.doctorId] = {
        ...event,
        label: event?.clinicName,
        value: event,
      }
    })
    let values = Object.values(filteredUserData)
    setSelectedUsersData(values)

    if (refData.current?.selectedId) {
      setActiveUsers(refData.current.data.value)
      refData.current = {}
    } else {
      setActiveUsers(allLabelData)
    }
  }, [selectedEvents])

  useEffect(() => {
    const filteredData = allEvents.filter((event) => {
      const eventStartDate = new Date(event.start)
      const eventEndDate = new Date(event.end)

      let res =
        eventStartDate.toDateString() === currentDate.toDateString() ||
        eventEndDate.toDateString() === currentDate.toDateString()
      return res
    })

    setSelectedEvents(filteredData)
  }, [currentDate, allEvents])

  const handleDateSelect = (slotInfo) => {
    console.log("handleDateSelect", slotInfo)
    const clickedDate = slotInfo.start

    if (!slotInfo?._id) {
      const selectedDateField = new Date(clickedDate)
      const today = new Date()

      selectedDateField.setHours(0, 0, 0, 0)
      today.setHours(0, 0, 0, 0)

      if (selectedDateField >= today) {
        let start = slotInfo.start 
        
        let end = new Date(start)
        end.setHours(start.getHours() + 1) // Add 1 hour to start time
        
        onSelectEventCard(
          {
            title: CREATE_APPOINTMENT,
            ...slotInfo,
            end,
            appointmentType: BREAK,
            isEditing: false
          }
        )
      }
    }
    setSelectedDate(clickedDate)
    setCurrentDate(clickedDate)
  }

  const onSelectEvent = (e, d) => {
    console.log("onSelectEvent", e, d, selectedEvents, refData)
    handleDateSelect(e)
    refData.current = {
      selectedId: e.doctorId,
      data: { value: e, label: e?.clinicName },
    }

    if (view === "month") {
      setView("day")
    }
  }

  const sortedArray = allEvents?.sort(function (a, b) {
    return new Date(a?.start) - new Date(b?.start)
  })

  const groups = sortedArray?.reduce((groups, event) => {
    const startDate = new Date(event?.start)
    const date = `${startDate?.getDate()}-${startDate?.getMonth()}-${startDate?.getFullYear()}`
    if (!groups[date]) {
      groups[date] = []
    }
    groups[date]?.push({ ...event, date })
    return groups
  }, {})

  const groupArrays = Object?.keys(groups)?.map((date) => {
    return {
      date,
      events: groups[date],
    }
  })

  // const outputArray = [];
  // for (let each of groupArrays) {
  //     const alldayEvents = each?.events?.filter((all) => all?.allDay);
  //     const firstEvent = each?.events?.filter((all) => !all.allDay)?.[0];
  //     outputArray?.push(...alldayEvents, firstEvent);
  // }

  function onCloseModal() {
    setModalData({})
  }

  function onClickMore(events) {
    setModalData({
      show: true,
      events,
      onClose: onCloseModal,
      showSecondButton: false,
      title: getMonthFormattedDate(events?.[0]?.start),
    })
  }

  const [showDaySchedule, setShowDaySchedule] = useState(true)

  console.log("seeelect", { selectedEvents, allEvents })
  const [modalData, setModalData] = useState()

  function DayScheduleModal() {
    return (
      <BasicModal {...modalData}>
        <div style={{ padding: "20px", maxHeight: "300px", overflowY: "auto" }}>
          <EventCards events={selectedEvents} />
        </div>
      </BasicModal>
    )
  }

  const [mergedEvents, setMergedEvents] = useState([])

  useEffect(() => {
    let data = getGroupedEvents(allEvents)
    setMergedEvents(data)
  }, [allEvents])

  const handleChange = (e) => {
    // console.log("setActiveUsers", e.target.value)
    setActiveUsers(e.target.value)
  }

  const calendarData = {
    groupArrays,
    onClickMore,
    view,
    mergedEvents,
    allEvents,
    currentDate,
    handleDateSelect,
    onSelectEvent,
    selectedDate,
    handleNavigate,
    handleView,
    handleToday,
  }

  const sideBarData = {
    selectedEvents,
    selectedDate,
    selectedUsersData,
    activeUsers,
    handleChange,
    filteredEvents,
    getScheduleData,
    onSelectEventCard
  }

  // console.log("mergedEventsmergedEvents", { mergedEvents, selectedEvents, selectedUsersData })

  return (
    <div style={{ border: "0px solid blue", width: "100%" }}>
      {showDaySchedule && <DayScheduleModal />}

      <Grid container spacing={2}>
        <CalendarComponents {...calendarData} />

        <Sidebar {...sideBarData} />
      </Grid>
    </div>
  )
}

export default CalenderSection
